export enum ReviewLockState {
  LOCKED = "LOCKED",
  UNLOCKED = "UNLOCKED",
  DISABLED = "DISABLED",
}
